import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';

   import RegisterLogin from './components/Login/Login';
import { ToastContainer, toast } from "react-toastify";
 import CompanyPage from './components/Companypage/CompanyPage';
 import { Home } from './components/Dashboard/Home';
import './App.css';
 import MultiFactor from './components/Dashboard/userprofile/MultiFactor';
import PreventNavigation from './NavigationBloker';
import MyContacts from './components/myContacts/MyContacts';
import Contacts from './components/contacts/Contacts';
import MyList from './components/myList/MyList';
 import axios from 'axios';
import LandingPage from './components/Landingpage/LandingPage';
import Features from './components/Landingpage/Features';
import Pricing from './components/Landingpage/Pricing';
import LandContact from './components/Landingpage/LandContact';
import FreeTrial from './components/Landingpage/FreetTial';

// AuthenticatedRoute defined inline or you can move it to another file
const AuthenticatedRoute = ({ isLoggedIn, element }) => {
  return isLoggedIn ? element : <Navigate to="/" />;
};

function App() {
const [isLoggedIn, setIsLoggedIn] = useState(false);
  const[isAuthChecked, setIsAuthChecked] = useState(false)
  const [researcherId, setResearcherId] = useState();

  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

 const fetchResearcherId = async () => {
        try {
          const response = await axios.get(`${baseURL}/api/get-researcherid`);
          setResearcherId(response.data.researcherId);
        } catch (err) {
          console.error(
            "Failed to fetch researcher ID:",
            err.response?.data?.message || err.message
          );
        }
      };
  

  useEffect(() => {
      fetchResearcherId();
    }, []);

  useEffect(() => {
    const campaignSent = localStorage.getItem("campaignSent");

    if (campaignSent === "true") {
      toast.success("Your campaign has been sent successfully!", {
        position: "bottom-right",
        autoClose: 5000,
      });

      // clear the flag so it doesn't show again on refresh
      localStorage.removeItem("campaignSent");
    }
  }, []);


  // Check login status on initial load
  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
    setIsAuthChecked(true);
  }, []);
     if(!isAuthChecked) {
      return <div>Loading...</div>
      
     }

     const handleLogin = () => {
      setIsLoggedIn(true);
      localStorage.setItem('isLoggedIn', 'true');
    };

  const handleLogout = () => {
  setIsLoggedIn(false);
  localStorage.removeItem('isLoggedIn');
  window.location.replace("/");
};

  return (
    <>
    <Router>
    {/* <ResearcherProvider> */}
       <PreventNavigation /> 
      <Routes>
     
    <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact" element={<LandContact />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path='/free-trial' element={<FreeTrial />} />


           <Route path="/login" element={<RegisterLogin onLogin={handleLogin} />} />  
        {/* <Route path="/" element={ <RegisterLogin onLogin={handleLogin} />   */}
             {/* } />    */}
        
        {/* <Route path="/companies" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Companies />} />} /> */}
         <Route path="/contacts" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Contacts />} />}/>
        <Route path="/my-contacts" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<MyContacts fetchResearcherId ={fetchResearcherId}/>} />}/>
        <Route path="/my-list" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<MyList />} />}/>
        <Route path="/admin" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Contacts />} />} />
        <Route path="/researcher" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Contacts />} />} />
        <Route path="/companypage/:id" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<CompanyPage />} />} />
        <Route path="/companypage/:listname/:id" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<CompanyPage />} />} />
        <Route path="/dashboard" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/billingandpayment" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/subscription" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/termsandconditions" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/userprofile' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/accountowner' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/mail' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} /> 
         <Route path='/mail/:id' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} /> 
         <Route path='/mail/:listName/:id' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} /> 
         <Route path='/multifactor' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<MultiFactor />} />} />
        <Route path='/crm' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/deals' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/activities' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/user-management" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/billingandpayment/:id" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/campaign" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/campaign/:id' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path='/campaign/:listName/:id' element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/analysis/:campaignId" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/allmail" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
        <Route path="/template" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />
          <Route path="/mytemplate" element={<AuthenticatedRoute isLoggedIn={isLoggedIn} element={<Home />} />} />  
      </Routes>

    </Router>
    <ToastContainer />
    </>
  );
}

export default App;